/*
 * @Author: hepeng
 * @Date: 2019-08-03 20:07:14
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-08-06 10:55:02
 */
function newCode(num, code) {
    this.codeNum = num;
    this.codeList = [];
    this.color = "#3755a9";
    this.code = code;
    this.eachCode();
}

newCode.prototype = {
    initCode(code) {
        this.codeList = [];
        this.code = code;
    },
    resizeCode(code) {
        this.initCode(code);
        this.eachCode();
    },
    eachCode() {
        for (var i = 0; i < this.code.length; i++) {
            this.codeList.push({
                code: this.code[i],
                color: this.color,
                fontSize: `1${[Math.floor(Math.random() * 10)]}px`,
                transform: `rotate(${Math.floor(Math.random() * 30) - Math.floor(Math.random() * 30)}deg)`
            })
        }
    }
}

export default newCode;